<template>
    <section class="container mx-auto py-8 px-4 md:px-8">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <!-- Contact Form -->
            <div class="bg-white shadow-lg rounded-lg p-6">
                <h2 class="text-2xl font-bold text-gray-800 mb-4">Get in Touch</h2>
                <form @submit.prevent="handleSubmit" class="space-y-4">
                    <div>
                        <label for="name" class="block text-sm font-medium text-gray-700">Your Name</label>
                        <input type="text" id="name" v-model="name" required
                            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500" />
                    </div>
                    <div>
                        <label for="email" class="block text-sm font-medium text-gray-700">Your Email</label>
                        <input type="email" id="email" v-model="email" required
                            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500" />
                    </div>
                    <div>
                        <label for="message" class="block text-sm font-medium text-gray-700">Your Message</label>
                        <textarea id="message" v-model="message" required rows="4"
                            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"></textarea>
                    </div>
                    <button type="submit"
                        class="w-full bg-green-600 text-white py-2 px-4 rounded-md shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2">
                        Send Message
                    </button>
                </form>
            </div>

            <!-- Map View -->
            <div class="relative">
                <iframe src="https://maps.app.goo.gl/zNsuV3Rqzff9CmrB7" style="border: 0; width: 100%; height: 100%;"
                    allowfullscreen="" loading="lazy" class="rounded-lg shadow-lg">
                </iframe>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            name: '',
            email: '',
            message: '',
        };
    },
    methods: {
        handleSubmit() {
            alert(`Thank you, ${this.name}! Your message has been sent.`);
            // Reset form
            this.name = '';
            this.email = '';
            this.message = '';
        },
    },
};
</script>

<style scoped></style>
